import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/enum';

import C償却List from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/償却List/償却List.vue';
import C償却EditRow from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/償却EditRow/償却EditRow.vue';
import C減価償却Total from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/減価償却Total/減価償却Total.vue';
import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 償却EditableListMixin from '@/entries/user/mixins/償却EditableListMixin';

import { 科目別償却合計Keys } from '@/classes/service/分析計画/償却Service';

export default mixins(RoutesMixin, 償却EditableListMixin).extend({
  name: 'P償却不足額',

  components: {
    C償却List,
    C償却EditRow,
    C減価償却Total,
    MoneyUnitSelect,
  },

  data(): {
    isSimple: boolean;
    科目別償却合計Keys: typeof 科目別償却合計Keys;
  } {
    return {
      isSimple: false,
      科目別償却合計Keys: 科目別償却合計Keys,
    };
  },

  async created(): Promise<void> {
    // 初期設定
    this.initialize償却Service(Eフェーズ種別.分析フェーズ, '償却不足額');
  },
});
